export default "<span *ngIf=\"isLoggin\">\n    <app-navbar></app-navbar>\n</span>\n<router-outlet></router-outlet>"